'use client';

import { Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

export default function CoolbluesChoiceExplanation({ children }: { children: string }) {
  const { t, Trans } = useTranslation('webshop');

  return (
    <Typography variant='h6' component='span'>
      <Trans
        t={t}
        shouldUnescape
        i18nKey='filterPage.coolbluesChoice.explanation'
        values={{ coolbluesChoiceExplanation: children }}
      />
    </Typography>
  );
}
